import {
    Component,
    Input,
    ElementRef,
    Renderer2,
    ComponentFactoryResolver,
    Injector,
    ViewContainerRef,
    ViewEncapsulation,
    Output,
    EventEmitter,
    ViewChild,
    OnDestroy
} from '@angular/core';

import { AdaptiveRenderCta } from './adaptiveRenders/CTA/adaptiveRender-cta.component';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'card-adaptive',
    template: `<div class="card-adaptive"><ng-template #container></ng-template></div>`,
    entryComponents: [AdaptiveRenderCta],
    styleUrls: ['renderCardAdaptive.component.scss']
})
export class RenderCardAdaptive implements OnDestroy{

    @Input() data: any;

    @Output() clickEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('container', { read: ViewContainerRef, static: true }) viewContainer: ViewContainerRef;

    // component que sera gerado dinamicamente
    private Component;

    // lista de compoennets
    private entryComponentsArray = {
        "AdaptiveCard": AdaptiveRenderCta
    }
    clickSubscription: Subscription;

    constructor(
        private factoryResolver: ComponentFactoryResolver,
        private viewContainerRef: ViewContainerRef
    ) {}

    ngOnInit() {
        this.createMessageComponent(this.entryComponentsArray[this.data.type])
            .renderActions(this.data.actions)
            .renderBody(this.data.body)
            .postItMessage();
    }

    createMessageComponent(comp) {
        this.Component = this.factoryResolver
            .resolveComponentFactory(comp)
            .create(this.viewContainer.parentInjector);
        return this;
    }

    renderActions(actions) {
        this.Component.instance.data = this.Component.instance.data.concat(actions);
        return this;
    }

    renderBody(body) {
        this.Component.instance.data = this.Component.instance.data.concat(body);
        return this;
    }

    postItMessage() {
        this.subscribeClickEvent();
        this.viewContainer.insert(this.Component.hostView);
    }

    // subscribe in emmiter component child
    subscribeClickEvent() {
        if (this.Component.instance.clickEvent) {
            this.clickSubscription = this.Component.instance.clickEvent
                .take(1)
                .subscribe(event => {
                    this.clickEvent.emit(event);
                });
        }
    }


    //não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    ngOnDestroy() { }

}
